import { PermissionRepository } from "../repositories/PermissionRepository";
import { PermissionsMap } from "../entities/PermissionEntity";

/**
 * Get My Permissions Use Case
 * Retrieves current user's permissions
 */
export class GetMyPermissionsUseCase {
  constructor(private repository: PermissionRepository) {}

  async execute(): Promise<PermissionsMap> {
    return await this.repository.getMyPermissions();
  }
}
